/*
* Broadcast Theme
*
* Use this file to add custom Javascript to Broadcast.  Keeping your custom
* Javascript in this fill will make it easier to update Broadcast. In order
* to use this file you will need to open layout/theme.liquid and uncomment
* the custom.js script import line near the bottom of the file.
*/


(function() {
  // Add custom code below this line

document.addEventListener('DOMContentLoaded', function() {
    // 1. Guard against null references when updating subtotal and cart totals
    const patchCartItems = function() {
      if (!window.customElements || !customElements.get('cart-items')) return;

      const CartItems = customElements.get('cart-items');
      if (!CartItems || !CartItems.prototype) return;

      const originalBuild = CartItems.prototype.build;
      if (typeof originalBuild !== 'function') return;

      CartItems.prototype.build = function(t) {
        // Fallback element assignment if missing in the mobile drawer DOM
        if (!this.cartTotal) {
          this.cartTotal = this.querySelector('[data-cart-total]') || document.querySelector('[data-cart-total]');
        }
        if (!this.cartEmpty) {
          this.cartEmpty = this.querySelector('[data-cart-empty]') || document.querySelector('[data-cart-empty]');
        }

        // Safely execute original build logic
        try {
          originalBuild.call(this, t);
        } catch (err) {
          // If elements are missing on mobile, handle text assignment manually without breaking JS execution
          if (this.subtotal !== undefined && window.theme && window.theme.strings) {
            const formattedTotal = (this.subtotal === 0) 
              ? window.theme.strings.free 
              : (typeof Oe === 'function' ? Oe(this.subtotal, theme.moneyWithCurrencyFormat) : this.subtotal);

            if (this.cartTotal) {
              this.cartTotal.innerHTML = formattedTotal;
            }
          }
        }
      };
    };

    patchCartItems();
  });
  




  // ^^ Keep your scripts inside this IIFE function call to 
  // avoid leaking your variables into the global scope.
})();
